import React from "react";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";

const Term = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-b from-yellow-100 to-gray-100 min-h-screen">
      {/* Hero Banner */}
      <div className="bg-blue-900 text-white py-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 animate-fade-in">
            Terms & Conditions
            <span className="block text-yellow-500 mt-2">
              Our Commitment to You
            </span>
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto mb-6">
            By using Virtueista IT’s services, you agree to these terms and
            conditions governing our courses and software solutions.
          </p>
        </div>
      </div>

      {/* Terms Content */}
      <div className="max-w-4xl mx-auto px-4 py-12 md:py-16">
        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Introduction
            </h2>
            <p className="text-gray-600">
              These Terms and Conditions govern your use of Virtueista IT’s
              website, training programs, and software services in Biratnagar,
              Nepal. By accessing or using our services, you agree to comply
              with these terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. User Responsibilities
            </h2>
            <p className="text-gray-600">As a user, you agree to:</p>
            <ul className="list-disc pl-5 text-gray-600">
              <li>
                Provide accurate information during registration or inquiries.
              </li>
              <li>Use our services for lawful purposes only.</li>
              <li>
                Not reproduce or distribute course materials without permission.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Intellectual Property
            </h2>
            <p className="text-gray-600">
              All content on our website and in our courses, including text,
              videos, and software, is owned by Virtueista IT. Unauthorized use
              or distribution is prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Course Enrollment
            </h2>
            <p className="text-gray-600">
              Enrollment in our training programs is subject to:
            </p>
            <ul className="list-disc pl-5 text-gray-600">
              <li>Payment of applicable fees.</li>
              <li>Adherence to course schedules and guidelines.</li>
              <li>
                No guarantee of specific outcomes or certifications unless
                stated.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Limitation of Liability
            </h2>
            <p className="text-gray-600">Virtueista IT is not liable for:</p>
            <ul className="list-disc pl-5 text-gray-600">
              <li>
                Indirect or consequential damages from using our services.
              </li>
              <li>Interruptions due to technical issues beyond our control.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              6. Contact Us
            </h2>
            <p className="text-gray-600">
              For questions about these Terms and Conditions, contact us at{" "}
              <a
                href="mailto:virtueistait@gmail.com"
                className="text-blue-600 hover:underline"
              >
                virtueistait@gmail.com
              </a>{" "}
              or call +977-9849489441.
            </p>
          </section>
        </div>
      </div>

      {/* Call to Action */}
      <div className="text-center bg-blue-800 text-white py-12 px-4">
        <h2 className="text-3xl font-bold mb-4">Need Clarification?</h2>
        <p className="text-lg max-w-2xl mx-auto mb-6">
          Our team is here to assist with any questions about our terms.
        </p>
        <button
          onClick={() => navigate("/contact")}
          className="bg-yellow-500 text-blue-900 py-3 px-6 rounded-md font-semibold hover:bg-yellow-600 transition-all duration-300"
        >
          Contact Us
        </button>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/9779849489441"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 z-50"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 animate-spin-slow" />
      </a>

      {/* Inline CSS for Animations */}
      <style>
        {`
          @keyframes fade-in {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in {
            animation: fade-in 1s ease-out;
          }
          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animate-spin-slow {
            animation: spin-slow 4s linear infinite;
          }
        `}
      </style>
    </div>
  );
};

export default Term;
